import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import { getHallViewAuditTrackerList_action } from "../../../../actions/admin_module_action/preSetupTracker_action/hallView_action";
import {
  getLayoutViewAuditTrackerList_action,
  getZoneData_action,
} from "../../../../actions/admin_module_action/preSetupTracker_action/layoutView_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
import SvgCanvas from "./SvgCanvas";
import VendorTaskDetail from "../../../vendor_module/vendor_task/vendor_task_detail";

// The per-service manual forms, opened from the info icon in the booth popup -
// the same set, and the same dispatch, the Hall Manager work updation screen uses.
import FasciaForm from "../../../exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import ExhibitorBadge from "../../../exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge";
import ExhibitorDetails from "../../../exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import VisaApplication from "../../../exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationList";
import EDirectoryList from "../../../exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_list";
import KeywordsInformation from "../../../exhibitor_module/manual_forms/forms/keywords_information_form/keywords_information";
import StallDesign from "../../../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import AdditionalFurniture from "../../../exhibitor_module/manual_forms/forms/additional furniture/additional_furniture";
import StallPossession from "../../../exhibitor_module/manual_forms/forms/stall_possesion/stall_possesion";
import PowerConnection from "../../../exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import FreightForward from "../../../exhibitor_module/manual_forms/forms/freight_forward/freight_forward";
import Water from "../../../exhibitor_module/manual_forms/forms/water_form/water";
import AirConnectionApplication from "../../../exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import CarPassesApplication from "../../../exhibitor_module/manual_forms/forms/car_passes_application/car_passes_application";
import LiquareLicense from "../../../exhibitor_module/manual_forms/forms/liquare_license/liquare_license";
import LeadRetrievalConnectionApplication from "../../../exhibitor_module/manual_forms/forms/leadRetrievalConnectionApplication/leadRetrievalConnectionApplication";
import MeetingRoomRequestForm from "../../../exhibitor_module/manual_forms/forms/Meeting room request form/MeetingRoomRequestForm";
import DelegateMeeting from "../../../exhibitor_module/manual_forms/forms/delegate_meeting/delegate_meeting";
import VisitorMeetingApplication from "../../../exhibitor_module/manual_forms/forms/visitor_meeting_application/visitor_meeting_application";
import InternetConnection from "../../../exhibitor_module/manual_forms/forms/internet_connection/internet_connection";
import HousekeepingConnection from "../../../exhibitor_module/manual_forms/forms/housekeeping_connection/housekeeping_connection";
import SecurityApplication from "../../../exhibitor_module/manual_forms/forms/security_application/security_application";
import CateringServices from "../../../exhibitor_module/manual_forms/forms/catering_services/catering_services";
import HostHostessRequirements from "../../../exhibitor_module/manual_forms/forms/host_hostess_requirement/host_hostess_requirement";
import BrandingOpportunityAndAdvertisement from "../../../exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";
import RentalAudioAndVideoEquipment from "../../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import ExhibitorContractorBadgeApplication from "../../../exhibitor_module/manual_forms/forms/exhibitor_contractor_badgeApplication/exhibitor_contractor_badgeApplication";
import PlantAndBeautification from "../../../exhibitor_module/manual_forms/forms/PlantAndBeautification/PlantAndBeautification";
import RentalAudioAndVedioEquipment from "../../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class LayoutView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      // Multi-mode filters and SP 4-dataset states
      viewFilter: "stall", // "stall" | "zone" | "hall"
      dataFilters: ["service_partner", "exhibitor_orders", "daily_routine"],
      hallZoneMasterRows: [], // result set 0 (data): Halls & Zones master
      servicePartnerRows: [], // result set 1 (data1): Service Partner tasks
      exhibitorOrderRows: [], // result set 2 (data2): Exhibitor orders / services
      dailyRoutineRows: [], // result set 3 (data3): Daily routine tasks
      // Raw rows from getHallViewAuditTrackerList - backwards compatibility
      taskRows: [],
      exhibitorRows: [],
      isTaskLoading: true,
      // Set when the tracker call itself fails, so the popup can say "the
      // request failed" instead of "there are no rows" - they looked identical
      // and sent us hunting in the wrong place.
      taskLoadError: null,
      // Layout SVG related states
      layouts: [],
      selectedLayoutId: null,
      layoutError: null,
      isLayoutLoading: true,
      // Hall & Booth filter states for auto-zoom
      filterHallId: "",
      filterBoothId: "",
      // Halls/booths parsed out of the layout SVG
      svgHalls: [],
      svgBooths: [],
      // Zone data for the selected hall (data = zones, data2 = stalls per zone)
      zoneData: [],
      zoneStalls: [],
      selectedZoneId: "",
      isZoneLoading: false,
      zoneError: null,
      // Only the Organizer verifies, the same rule the vendor task screen applies.
      // sp_get_hallviewauditTracker does not carry the verification columns, so the
      // state is read from the task API and merged onto the tracker rows by
      // ExhVendorPlanDtlID - that also brings the plan header id a save needs
      // Super Admin and Admin both, the same pair treated as the Organizer team by
      // the task notifications. Both session stores are used for the role across
      // this codebase and neither is set on every route, so whichever one answers
      // decides
      isOrganizer: [
        sessionStorage.getItem("RoleIDSS"),
        JSON.parse(sessionStorage.getItem("loginDataSS") || "{}").RoleID,
      ].some((role) => role == 6 || role == 2),
      // The Hall Manager verifies one step before the Organizer. Read from both
      // session stores for the same reason isOrganizer is.
      isHallManagerRole: [
        sessionStorage.getItem("RoleIDSS"),
        JSON.parse(sessionStorage.getItem("loginDataSS") || "{}").RoleID,
      ].some((role) => role == 16),
      verificationById: {},
      // The task screen, opened over the map with this booth's rows filtered in
      showTaskModal: false,
      taskModalFilter: null,
      // The manual form behind the info icon against each service
      isManualFormModalOpen: false,
      manualFormService: null,
      manualFormExhibitor: null,
    };

    this.loadLayouts = this.loadLayouts.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    this.getVendorTaskList();
    this.loadLayouts();
  }

  // The row carries IsCompleted: null so verifying never rewrites the completion
  // this screen read a moment ago - the same shape the vendor task screen sends
  // sp_get_hallviewauditTracker carries neither IsHallManagerApprove, the sub
  // points, the remarks, the attachments nor the approval stamps, so the popup
  // cannot honestly show the task screen's full set of columns. Rather than a
  // half-built copy, hand the organizer over to that screen with this booth's
  // hall / service / service partner already filtered in.
  // Driven by the toolbar, not by a booth. Whatever Hall and Service are
  // selected on the map is what the task list opens on - the SVG hall id and the
  // ServiceID are both resolved to the display names that screen filters by.
  // Same contract as work_updation.js: the form components read the
  // registration id out of sessionStorage, so it has to be set before the modal
  // mounts rather than passed as a prop.
  handleOpenManualForm = (serviceName, exhRegistrationID, exhibitorName) => {
    if (exhRegistrationID == null) return;
    sessionStorage.setItem("ExhRegistrationIDSS", exhRegistrationID);
    this.setState({
      isManualFormModalOpen: true,
      manualFormService: serviceName,
      manualFormExhibitor: exhibitorName || null,
    });
  };

  renderManualForm(ServiceName) {
    if (ServiceName === "Fascia") {
      return <FasciaForm />;
    } else if ((ServiceName || "").trim() === "Exhibitor Paid Badges") {
      return <ExhibitorBadge />;
    } else if ((ServiceName || "").trim() === "exhibitorDetails") {
      return <ExhibitorDetails />;
    } else if ((ServiceName || "").trim() === "Visa Application  ") {
      return <VisaApplication />;
    } else if ((ServiceName || "").trim() === "edirectoryList") {
      return <EDirectoryList />;
    } else if ((ServiceName || "").trim() === "Keywords") {
      return <KeywordsInformation />;
    } else if ((ServiceName || "").trim() === "Stall Design") {
      return <StallDesign />;
    } else if ((ServiceName || "").trim() === "Furniture") {
      return <AdditionalFurniture />;
    } else if ((ServiceName || "").trim() === "Stall Possession") {
      return <StallPossession />;
    } else if ((ServiceName || "").trim() === "Power") {
      return <PowerConnection />;
    } else if ((ServiceName || "").trim() === "Freight Forwarders") {
      return <FreightForward />;
    } else if ((ServiceName || "").trim() === "Water") {
      return <Water />;
    } else if ((ServiceName || "").trim() === "Air") {
      return <AirConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Car Passes") {
      return <CarPassesApplication />;
    } else if (ServiceName === "Liquor License") {
      return <LiquareLicense />;
    } else if ((ServiceName || "").trim() === "Lead Retrieval") {
      return <LeadRetrievalConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Meeting Room") {
      return <MeetingRoomRequestForm />;
    } else if ((ServiceName || "").trim() === "delegateMeeting") {
      return <DelegateMeeting />;
    } else if ((ServiceName || "").trim() === "visitorMeetingApplication") {
      return <VisitorMeetingApplication />;
    } else if ((ServiceName || "").trim() === "Internet Connection") {
      return <InternetConnection />;
    } else if ((ServiceName || "").trim() === "Housekeeping") {
      return <HousekeepingConnection />;
    } else if ((ServiceName || "").trim() === "Security") {
      return <SecurityApplication />;
    } else if ((ServiceName || "").trim() === "Catering") {
      return <CateringServices />;
    } else if ((ServiceName || "").trim() === "Host and Hostess") {
      return <HostHostessRequirements />;
    } else if ((ServiceName || "").trim() === "Branding Opportunity  ") {
      return <BrandingOpportunityAndAdvertisement />;
    } else if ((ServiceName || "").trim() === "AV Equipments ") {
      return <RentalAudioAndVideoEquipment />;
    } else if ((ServiceName || "").trim() === "Contractor Badge  ") {
      return <ExhibitorContractorBadgeApplication />;
    } else if ((ServiceName || "").trim() === "plantAndBeautification") {
      return <PlantAndBeautification />;
    } else {
      return null; // or <NotFound />
    }
  }

  handleOpenTaskDetail = () => {
    const { filterHallId, serviceId, svgHalls, serviceList } = this.state;

    const hall = svgHalls.find((h) => h.HallID === filterHallId);
    const service = (serviceList || []).find(
      (svc) => String(svc.ServiceID) === String(serviceId)
    );

    this.setState({
      showTaskModal: true,
      taskModalFilter: {
        hallName: hall ? hall.HallName : null,
        serviceName: service ? service.Name || service.DisplayName : null,
        // The toolbar has no service-partner filter, so that one stays open.
        vendorCompany: null,
        status: "all",
        // Kept for matching the exhibitor list - ids don't suffer the spelling
        // differences the display strings do.
        hallDbId: hall ? this.resolveDbHallId(hall.HallID) : null,
        serviceId: service ? service.ServiceID : null,
      },
    });
  };

  // Closing unmounts the screen, which stops its 15s poll and drops its state -
  // reopening on another booth then starts clean rather than showing the last
  // booth's rows for a beat.
  closeTaskModal = () => {
    this.setState({ showTaskModal: false, taskModalFilter: null }, () => {
      // Verifications made in there are the point of opening it, so pick them up
      this.getVendorTaskList();
    });
  };

  loadLayouts() {
    const exhibitionId = sessionStorage.getItem('sessionExhibitionID');

    if (!exhibitionId) {
      this.setState({ layoutError: "Exhibition ID not found", isLayoutLoading: false });
      return;
    }

    this.setState({ isLayoutLoading: true, layoutError: null });
    this.props
      .getLayoutViewAuditTrackerList_action(exhibitionId)
      .then((res) => {
        if (res && res.data && res.error === 0) {
          const layouts = res.data.map(layout => {
            // Derive halls from booths if halls array is empty/missing
            if ((!layout.halls || layout.halls.length === 0) && layout.booths && layout.booths.length > 0) {
              const hallMap = {};
              layout.booths.forEach(booth => {
                const hId = booth.HallId || booth.HallID;
                const hName = booth.HallName;
                if (hId && hName && !hallMap[hId]) {
                  hallMap[hId] = { HallID: hId, HallName: hName };
                }
              });
              layout.halls = Object.values(hallMap);
            }
            return layout;
          });
          this.setState({
            layouts,
            isLayoutLoading: false,
            selectedLayoutId: layouts.length > 0 ? layouts[0].MstHallLayoutID : null,
            layoutError: null,
          });
        } else {
          this.setState({
            isLayoutLoading: false,
            layoutError: res?.msg || "Failed to load layouts",
          });
        }
      })
      .catch((err) => {
        console.error("Error loading layouts:", err);
        this.setState({
          isLayoutLoading: false,
          layoutError: "Error loading layouts",
        });
      });
  }

  handleLayoutSelect = (layoutId) => {
    this.setState({
      selectedLayoutId: layoutId,
      filterHallId: "",
      filterBoothId: "",
      zoneData: [],
      zoneStalls: [],
      selectedZoneId: "",
      zoneError: null,
      isZoneLoading: false,
    });
  };

  // The hall dropdown carries SVG-derived ids ("H1", "H3") because the drawing
  // is the source of truth for what can be selected. The zone API needs the
  // database HallId, so resolve across on hall name — the one field both sides
  // agree on. Prefer the master hall list; fall back to the layout payload.
  resolveDbHallId = (svgHallId) => {
    const { svgHalls, hallList, layouts, selectedLayoutId } = this.state;
    const hall = svgHalls.find((h) => h.HallID === svgHallId);
    if (!hall) return null;

    const key = String(hall.HallName || "").trim().toLowerCase();
    const match = (hallList || []).find(
      (h) => String(h.HallName || "").trim().toLowerCase() === key
    );
    if (match) return match.HallId != null ? match.HallId : match.HallID;

    const layout = (layouts || []).find((l) => l.MstHallLayoutID === selectedLayoutId);
    const apiHall = (layout && layout.halls ? layout.halls : []).find(
      (h) => String(h.HallName || "").trim().toLowerCase() === key
    );
    return apiHall ? (apiHall.HallID != null ? apiHall.HallID : apiHall.HallId) : null;
  };

  handleFilterHallChange = (hallId) => {
    this.setState({ filterHallId: hallId, filterBoothId: "" }, () => {
      this.getZoneData(hallId);
    });
  };

  handleZoneChange = (zoneId) => {
    this.setState({ selectedZoneId: zoneId, filterBoothId: "" });
  };

  // getVendorTaskList already forwards serviceId to the API, so filtering
  // server-side keeps the legend counts and the popup's service list
  handleViewFilterChange = (viewFilter) => {
    this.setState({ viewFilter });
  };

  handleDataFilterChange = (dataFilters) => {
    this.setState({ dataFilters });
  };

  // Frontend-filtered service selection
  handleServiceChange = (serviceId) => {
    this.setState({ serviceId });
  };

  // Task/vendor/exhibitor detail for the booth popup.
  // sp_get_hallviewauditTracker returns 4 result sets:
  // 0: Master Hall & Zone mapping (data)
  // 1: Service Partner Tasks (data1)
  // 2: Exhibitor Orders & Services (data2)
  // 3: Daily Routine Checklist Tasks (data3)
  async getVendorTaskList() {
    this.setState({ isTaskLoading: true });
    try {
      const res = await this.props.getHallViewAuditTrackerList_action(
        "", "", "", "", "", "", "", ""
      );
      if (!res || res.error === 1) {
        const msg = (res && (res.msg || res.errormsg)) || "no response";
        console.error("[layoutView] tracker call failed:", msg, res);
        this.setState({
          hallZoneMasterRows: [],
          servicePartnerRows: [],
          exhibitorOrderRows: [],
          dailyRoutineRows: [],
          taskRows: [],
          exhibitorRows: [],
          isTaskLoading: false,
          taskLoadError: `Tracker request failed: ${msg}`,
        });
        return;
      }

      // Collect candidate result sets from various response layouts
      const candidates = [];
      const collect = (value) => {
        if (!Array.isArray(value) || value.length === 0) return;
        if (Array.isArray(value[0])) {
          value.forEach(collect);
          return;
        }
        if (typeof value[0] === "object") candidates.push(value);
      };
      collect(res.data);
      collect(res.data1);
      collect(res.data2);
      collect(res.data3);

      const hasField = (rows, field) =>
        rows.some((row) => row && row[field] != null);

      // Result set 0 (data): Master Halls & Zones
      let hallZoneMasterRows =
        (Array.isArray(res.data) && typeof res.data[0] === "object" && res.data[0].ZoneID != null && res.data[0].HallID != null)
          ? res.data
          : candidates.find((rows) => hasField(rows, "ZoneID") && hasField(rows, "HallID") && !hasField(rows, "VendorCompanyName") && !hasField(rows, "HMWorkupdationID")) || [];

      // Result set 1 (data1): Service Partner Tasks
      let servicePartnerRows =
        (Array.isArray(res.data1) && typeof res.data1[0] === "object")
          ? res.data1
          : candidates.find((rows) => hasField(rows, "VendorCompanyName") || hasField(rows, "StallTaskStatus")) || [];

      // Result set 2 (data2): Exhibitor Orders & Services
      let exhibitorOrderRows =
        (Array.isArray(res.data2) && typeof res.data2[0] === "object")
          ? res.data2
          : candidates.find((rows) => rows !== servicePartnerRows && (hasField(rows, "HMWorkupdationID") || hasField(rows, "AccoundID") || hasField(rows, "StallPossessionStatusID"))) || [];

      // Result set 3 (data3): Daily Routine Tasks
      let dailyRoutineRows =
        (Array.isArray(res.data3) && typeof res.data3[0] === "object")
          ? res.data3
          : candidates.find((rows) => hasField(rows, "DailyRoutineChecklistHdrID") || hasField(rows, "ProgramTitle")) || [];

      const legacyTaskRows = candidates.find((rows) => hasField(rows, "ExhVendorPlanDtlID")) || servicePartnerRows;
      const legacyExhibitorRows = servicePartnerRows.length > 0 ? servicePartnerRows : (candidates.find((rows) => hasField(rows, "ExhRegistrationID")) || []);

      console.info(
        "[layoutView] 4 result sets loaded:",
        "Master Halls/Zones:", hallZoneMasterRows.length,
        "| Service Partner Tasks:", servicePartnerRows.length,
        "| Exhibitor Orders:", exhibitorOrderRows.length,
        "| Daily Routine:", dailyRoutineRows.length
      );

      const flagOn = (v) => {
        const x = Array.isArray(v) ? v.find((i) => i != null) : v;
        return x === 1 || x === true;
      };
      const verificationById = {};
      legacyTaskRows.forEach((t) => {
        const id = t.ExhVendorPlanDtlID || t.HMWorkupdationID;
        if (id == null || verificationById[id]) return;
        verificationById[id] = {
          ExhVendorPlanHdrID: t.ExhVendorPlanHdrID,
          IsAdminApprove: flagOn(t.IsAdminApprove || t.IsVerifyByOrganizer),
          IsHallManagerApprove: flagOn(t.IsHallManagerApprove || t.IsVerifyByHallManager),
          AdminApprovalDateTime: t.AdminApprovalDateTime || t.IsVerifyByOrganizerDateTime || null,
          HallManagerApprovalDateTime: t.HallManagerApprovalDateTime || t.IsVerifyByHallManagerDateTime || null,
          IsCompleted: flagOn(t.IsCompleted || (t.IsVerifyByOrganizer && t.IsVerifyByHallManager)),
          CompletionDateTime: t.CompletionDateTime || null,
        };
      });

      this.setState({
        hallZoneMasterRows,
        servicePartnerRows,
        exhibitorOrderRows,
        dailyRoutineRows,
        taskRows: legacyTaskRows,
        exhibitorRows: legacyExhibitorRows,
        verificationById,
        isTaskLoading: false,
        taskLoadError:
          candidates.length === 0
            ? "The tracker returned no result sets."
            : null,
      });
    } catch (err) {
      console.error("Error in getVendorTaskList:", err);
      this.setState({
        hallZoneMasterRows: [],
        servicePartnerRows: [],
        exhibitorOrderRows: [],
        dailyRoutineRows: [],
        taskRows: [],
        exhibitorRows: [],
        isTaskLoading: false,
        taskLoadError: `Tracker request errored: ${err && err.message ? err.message : err}`,
      });
    }
  }

  getZoneData(svgHallId) {
    if (!svgHallId) {
      this.setState({ zoneData: [], zoneStalls: [], selectedZoneId: "", zoneError: null, isZoneLoading: false });
      return;
    }

    const dbHallId = this.resolveDbHallId(svgHallId);
    if (dbHallId == null) {
      const hall = this.state.svgHalls.find((h) => h.HallID === svgHallId);
      this.setState({
        zoneData: [],
        zoneStalls: [],
        selectedZoneId: "",
        isZoneLoading: false,
        zoneError: `"${hall ? hall.HallName : svgHallId}" is in the layout drawing but has no matching hall record, so zones could not be loaded.`,
      });
      return;
    }

    this.setState({ isZoneLoading: true, zoneError: null });
    this.props
      .getZoneData_action(dbHallId)
      .then((res) => {
        // Ignore a response for a hall the user has already moved away from.
        if (this.state.filterHallId !== svgHallId) return;
        if (res && res.error === 0) {
          // data  = zones for the hall, data2 = the stalls inside each zone
          this.setState({
            zoneData: res.data || [],
            zoneStalls: res.data2 || [],
            selectedZoneId: "",
            isZoneLoading: false,
          });
        } else {
          this.setState({
            zoneData: [],
            zoneStalls: [],
            selectedZoneId: "",
            isZoneLoading: false,
            zoneError: (res && res.msg) || "Failed to load zone data.",
          });
        }
      })
      .catch((err) => {
        console.error("Error loading zone data:", err);
        if (this.state.filterHallId !== svgHallId) return;
        this.setState({ zoneData: [], zoneStalls: [], selectedZoneId: "", isZoneLoading: false, zoneError: "Error loading zone data." });
      });
  }

  handleFilterBoothChange = (boothId) => {
    this.setState({ filterBoothId: boothId });
  };

  // Halls/booths as read out of the layout drawing. The API's booths[] carries
  // sequential placeholder ClipIds that do not correspond to this SVG, so the
  // drawing is the source of truth for what can actually be selected.
  handleSvgDataExtracted = ({ halls, booths }) => {
    this.setState({ svgHalls: halls || [], svgBooths: booths || [] });
  };

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data && data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorTaskList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
      layouts,
      selectedLayoutId,
      layoutError,
      isLayoutLoading,
      filterHallId,
      filterBoothId,
      grid,
      viewFilter,
      dataFilters,
      hallZoneMasterRows,
      servicePartnerRows,
      exhibitorOrderRows,
      dailyRoutineRows,
      taskRows,
      exhibitorRows,
      isTaskLoading,
      taskLoadError,
      svgHalls,
      zoneData,
      zoneStalls,
      selectedZoneId,
      isZoneLoading,
      zoneError,
      verificationById,
      isHallManagerRole,
      showTaskModal,
      taskModalFilter,
      isManualFormModalOpen,
      manualFormService,
      manualFormExhibitor,
    } = this.state;

    const selectedLayout = layouts.find(l => l.MstHallLayoutID === selectedLayoutId);

    // The legend counts booths, because that is what the map draws. Both read
    // the same StallTaskStatus the procedure grades each stall with, so the
    // legend and the drawing can never tell different stories.
    const STALL_TASK_STATUS = {
      1: "Completed",
      2: "InProgress",
      3: "Pending",
      4: "Delayed",
    };
    const seenStalls = new Set();
    const effectiveExhibitorRows = (servicePartnerRows && servicePartnerRows.length > 0) ? servicePartnerRows : exhibitorRows;
    const statusCounts = effectiveExhibitorRows.reduce((acc, row) => {
      const stall = String(row.StallName || row.Stall || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
      if (!stall || seenStalls.has(stall)) return acc;
      seenStalls.add(stall);
      const raw = Array.isArray(row.StallTaskStatus)
        ? row.StallTaskStatus.find((v) => v != null)
        : row.StallTaskStatus;
      // 5, and anything the procedure does not grade, is an unallocated stall.
      const key = STALL_TASK_STATUS[Number(raw)] || (typeof raw === "string" ? raw : null);
      if (!key) return acc;
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

    return (
      <>
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" className={RoleID == 16 ? "px-3" : "px-1"}>
              <section className="section" style={{ padding: 0 }}>
                {/* Layout SVG Display Section */}
                {layoutError && (
                  <div className="alert alert-info alert-dismissible fade show mb-4" role="alert">
                    <i className="ri-information-line me-2"></i>
                    {layoutError}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => this.setState({ layoutError: null })}
                    ></button>
                  </div>
                )}

                {/* ─── Container for Hall Layout View ─── */}
                <div className="layout-view-container mb-5 p-2" style={{ backgroundColor: '#f3f4f7' }}>


                  {isLayoutLoading ? (
                    <div className="bg-white p-5 rounded border text-center my-2">
                      <div className="spinner-border text-primary mb-3" style={{ width: "2.5rem", height: "2.5rem" }} role="status">
                        <span className="visually-hidden">Loading layout...</span>
                      </div>
                      <h6 className="fw-semibold text-dark mb-1">Loading Hall Layout Map...</h6>
                      <small className="text-muted d-block mb-3">Please wait while interactive layout SVG and booth allocations load.</small>

                      {/* Skeleton placeholders for mapped hall cards */}
                      <div className="mt-4 pt-3 border-top">
                        <small className="text-muted d-block text-start mb-2 fw-semibold">Mapped Halls Skeleton:</small>
                        <div className="row">
                          {[1, 2, 3].map((i) => (
                            <div key={i} className="col-md-6 col-lg-4 mb-3">
                              <div className="card shadow-sm border-0 bg-light p-3 text-start">
                                <div className="placeholder-glow">
                                  <span className="placeholder col-8 bg-secondary mb-2 rounded"></span>
                                  <span className="placeholder col-4 bg-secondary-subtle d-block rounded"></span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : layouts.length > 0 ? (
                    <>
                      {/* Layout Selector */}
                      {layouts.length > 1 && (
                        <div className="mb-4">
                          <label className="form-label fw-semibold">Select Layout:</label>
                          <div className="btn-group d-flex" role="group">
                            {layouts.map((layout) => (
                              <button
                                key={layout.MstHallLayoutID}
                                type="button"
                                className={`btn btn-sm flex-fill ${selectedLayoutId === layout.MstHallLayoutID
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                                  }`}
                                onClick={() => this.handleLayoutSelect(layout.MstHallLayoutID)}
                              >
                                {layout.LayoutName}
                                <span className="badge bg-secondary ms-2">
                                  {layout.halls ? layout.halls.length : layout.MappedHallsCount}
                                </span>
                              </button>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* SVG Canvas */}
                      {selectedLayout && (
                        <div className="layout-canvas-wrapper">
                          <SvgCanvas
                            layout={selectedLayout}
                            viewFilter={viewFilter}
                            dataFilters={dataFilters}
                            onViewFilterChange={this.handleViewFilterChange}
                            onDataFilterChange={this.handleDataFilterChange}
                            hallZoneMasterRows={hallZoneMasterRows}
                            servicePartnerRows={servicePartnerRows}
                            exhibitorOrderRows={exhibitorOrderRows}
                            dailyRoutineRows={dailyRoutineRows}
                            filterHallId={filterHallId}
                            filterBoothId={filterBoothId}
                            onFilterHallChange={this.handleFilterHallChange}
                            onFilterBoothChange={this.handleFilterBoothChange}
                            onSvgDataExtracted={this.handleSvgDataExtracted}
                            zones={zoneData}
                            selectedZoneId={selectedZoneId}
                            onZoneChange={this.handleZoneChange}
                            isZoneLoading={isZoneLoading}
                            zoneStalls={zoneStalls}
                            statusCounts={statusCounts}
                            isStatusLoading={isTaskLoading}
                            taskRows={taskRows}
                            exhibitorRows={effectiveExhibitorRows}
                            isTaskLoading={isTaskLoading}
                            taskLoadError={taskLoadError}
                            services={serviceList}
                            selectedServiceId={serviceId}
                            onServiceChange={this.handleServiceChange}
                            verificationById={verificationById}
                            onOpenTaskDetail={this.handleOpenTaskDetail}
                            onOpenManualForm={this.handleOpenManualForm}
                          />

                          {zoneError && (
                            <div className="alert alert-warning d-flex align-items-center py-2 px-3 mt-3 mb-0 small" role="alert">
                              <i className="ri-error-warning-line me-2"></i>
                              {zoneError}
                            </div>
                          )}

                          {/* Halls List - from the drawing, so it matches the dropdown */}
                          {/* {svgHalls.length > 0 && (
                            <div className="mt-4">
                              <h6>
                                <i className="ri-building-4-line me-2"></i>
                                Halls in Layout ({svgHalls.length})
                              </h6>
                              <div className="row">
                                {svgHalls.map((hall) => (
                                  <div key={hall.HallID} className="col-md-6 col-lg-4 mb-3">
                                    <div
                                      className={`card shadow-sm ${filterHallId === hall.HallID ? "border-primary" : ""}`}
                                      role="button"
                                      onClick={() => this.handleFilterHallChange(hall.HallID)}
                                    >
                                      <div className="card-body">
                                        <h6 className="card-title mb-2">
                                          <i className="ri-building-line me-2"></i>
                                          {hall.HallName}
                                        </h6>
                                        <small className="text-secondary d-block">
                                          <i className="ri-store-2-line me-1"></i>
                                          {hall.BoothCount} booths
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )} */}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="alert alert-secondary mb-0" role="alert">
                      <i className="ri-information-line me-2"></i>No hall layouts available for this exhibition.
                    </div>
                  )}
                </div>



                {/* The full task screen, over the map. Rendered only while open
                    so it mounts fresh and its poll stops on close. */}
                <Modal
                  isOpen={showTaskModal}
                  onRequestClose={this.closeTaskModal}
                  ariaHideApp={false}
                  style={{
                    overlay: { zIndex: 1050, backgroundColor: "rgba(0,0,0,0.5)" },
                    content: {
                      inset: "2vh 2vw",
                      padding: 0,
                      border: "none",
                      background: "transparent",
                      overflow: "hidden",
                    },
                  }}
                >
                  <div className="modal-content" style={{ height: "96vh", display: "flex", flexDirection: "column" }}>
                    <div className="modal-header py-3 text-white">
                      <h6 className="mb-0">
                        <i className="ri-list-check-2 me-2"></i>
                        Tasks
                        {taskModalFilter && taskModalFilter.hallName
                          ? ` — ${taskModalFilter.hallName}`
                          : ""}
                        {taskModalFilter && taskModalFilter.serviceName
                          ? ` · ${taskModalFilter.serviceName}`
                          : ""}
                      </h6>
                      <button
                        type="button"
                        className="btn-close ms-auto"
                        onClick={this.closeTaskModal}
                      ></button>
                    </div>
                    <div className="modal-body" style={{ overflowY: "auto", flex: 1 }}>
                      {showTaskModal && (
                        <VendorTaskDetail embedded taskFilter={taskModalFilter} />
                      )}
                    </div>
                  </div>
                </Modal>

                {/* Manual form for one service of one exhibitor. Rendered only
                    while open so each opening mounts the form fresh, after
                    ExhRegistrationIDSS has been set. */}
                <Modal
                  isOpen={isManualFormModalOpen}
                  onRequestClose={() => this.setState({ isManualFormModalOpen: false })}
                  shouldCloseOnEsc={true}
                  shouldCloseOnOverlayClick={true}
                  ariaHideApp={false}
                >
                  <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                      <div className="modal-header p-2">
                        <h6 className="modal-title">
                          {manualFormService || "Manual Form"}
                          {manualFormExhibitor ? ` — ${manualFormExhibitor}` : ""}
                        </h6>
                      </div>
                      <div className="modal-body">
                        {isManualFormModalOpen && this.renderManualForm(manualFormService)}
                      </div>
                      <div className="modal-footer py-1">
                        <button
                          className="btn btn-gray"
                          onClick={() => this.setState({ isManualFormModalOpen: false })}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal>
              </section>
            </main>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getHallViewAuditTrackerList_action,
    getLayoutViewAuditTrackerList_action,
    getZoneData_action,
  })(LayoutView)
);
